import React from 'react'
import { Grid, Skeleton } from '@mui/material'

/**
 * Skeleton Brand Cards list loader for Add new Vehicle.
 * @returns
 */

const BrandLoader: React.FC = () => {
  const items = new Array(30).fill('')
  return (
    <>
      <Skeleton variant='rounded' animation='wave' height={30} width={215} sx={{ mb: 2 }} />
      <Grid container spacing={1}>
        {items.map((_item, index) => {
          return (
            <Grid key={index} item xs={2}>
              <Skeleton variant='rounded' animation='wave' height={36} />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

export default BrandLoader
